// Dependencies
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
// Actions
import { updateType } from './redux/actions';
// Types
import { AppState } from '../../reducers';
import { Circuit } from './objects/circuit';

type Props = {
    circuit: Circuit | null
}

export function CircuitType(props: Props): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const circuitData = useSelector((state: AppState) => state.circuit.circuit);
    const type =  useSelector((state: AppState) => state.circuit.type);

    const onTypeChange = (event: { target: { value: any; }; }) => {
        dispatch(updateType(event.target.value));
    };

    useEffect(() => {
        dispatch(updateType(type ? type: ''));
    },[circuitData]);

    // recreate input
    useEffect(() => {
        if (props.circuit) {
            dispatch(updateType(props.circuit.type));
        }
    }, [props.circuit]);

    return (
        <FormControl fullWidth required>
            <InputLabel>{ t('shared.type') }</InputLabel>
            <Select required label={ t('shared.type') } value={ type ? type: '' } onChange={ onTypeChange }>
                <MenuItem value={ 'CIRCUIT' }>{ t('shared.circuit') }</MenuItem>
                <MenuItem value={ 'PACKAGE' }>{ t('shared.package') }</MenuItem>
                <MenuItem value={ 'MULTI_DAYS' }>{ t('shared.circuit-multi-days') }</MenuItem>
                <MenuItem value={ 'CRUISE' }>{ t('shared.circuit-cruise') }</MenuItem>
                <MenuItem value={ 'COMBINED' }>{ t('shared.circuit-combined') }</MenuItem>
            </Select>
        </FormControl>
    );
}
